import Vue from "vue";
import {useGlobalModalsStore} from "@iflat-ui/stores/globalModals";

export const GlobalModalsPlugin = {
  install(Vue) {
    const globalModalStore = {}
    Vue.prototype.$globalModalsStore = globalModalStore
    Vue.nextTick(() => {
      Vue.prototype.$globalModalsStore = useGlobalModalsStore()
    })
  }
}

Vue.use(GlobalModalsPlugin)
